import { APIErrorResponse, EmployeeInternalHoursDetail } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from '@/hooks/api/useQueryList'
import { QUERY_KEYS } from '@/constants'

export type HrInternalHoursEmployeeDetailParams = {
  year?: number
}

export const useHrInternalHoursEmployeeDetail = (
  userId: number | string,
  params: HrInternalHoursEmployeeDetailParams = {},
  enabled = true
): UseQueryResult<EmployeeInternalHoursDetail, APIErrorResponse> =>
  useQueryList({
    url: `/hours_reporting/hr/internal-hours/employee/${userId}/`,
    key: [...QUERY_KEYS.HR_INTERNAL_HOURS_EMPLOYEE_DETAIL, userId, params],
    options: { enabled },
    params,
  })
